<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1250px"
      title="丘成桐少年班六年级"
      id-key="Junior6Id"
      :data="data"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      :before-save="onBeforeSave"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <table class="report-table no-border" border="1">
              <tr>
                <td colspan="25">
                  <div v-if="data.EnrollNo">报名序号：{{data.EnrollNo}}</div>
                  <span v-else>报名序号：(<span class="red">系统自动生成</span>)</span>
                  <div class="center large" style="margin:6px 0;">{{year}}年汕头市金山中学“丘成桐少年班”六年级学生报名信息表</div>
                </td>
              </tr>
              <tr>
                <td class="center rq" style="width:10%;">姓名</td>
                <td class="center" colspan="9" style="width:32.5%;">
                  <el-input v-model="data.FullName" placeholder="请输入姓名" maxlength="10"></el-input>
                </td>
                <td class="center" style="width:10%;">性别</td>
                <td class="center" colspan="9" style="width:32.5%;">
                  <span v-if="data.Sex>0">{{data.Sex==1?"男":"女"}}</span>
                </td>
                <td class="center red bold small" rowspan="5" style="width:15%;">
                  <pic-upload v-if="!tbLoading" :data="{}" v-model="data.PicUrl" />
                </td>
              </tr>
              <tr>
                <td class="center rq" style="width:10%;">身份证</td>
                <td class="center" colspan="9">
                  <el-input v-model="data.IdCard" @blur="getBirth()" placeholder="请输入身份证号" maxlength="20"></el-input>
                </td>
                <td class="center rq" style="width:10%;">户籍地</td>
                <td class="center" colspan="9">
                  <el-select v-model="data.Domicile" filterable allow-create class="red-inp" @blur="selectInp($event,'Domicile')" clearable maxlength="50" placeholder="请选择或准确输入户籍地">
                    <el-option v-for="item in hjd" :key="item.BaseDataId" :value="item.DataName" />
                  </el-select>
                </td>
              </tr>
              <tr>
                <td class="center" style="width:10%;">出生日期</td>
                <td class="center" colspan="9">
                  <span>{{toDateString(data.BirthDate)}}</span>
                </td>
                <td class="center small rq" style="width:10%;">就读小学所在<br/>区县</td>
                <td class="center" colspan="9">
                  <el-select v-model="data.SchoolDistrict" filterable allow-create class="red-inp" @blur="selectInp($event,'SchoolDistrict')" maxlength="20" clearable placeholder="请选择或准确输入区县">
                    <el-option v-for="item in xxssqx" :key="item.BaseDataId" :value="item.DataName" />
                  </el-select>
                </td>
              </tr>
              <tr>
                <td class="center rq" style="width:10%;">就读小学</td>
                <td class="center" colspan="19">
                  <el-select v-model="data.PrimarySchool" filterable allow-create class="red-inp" @blur="selectInp($event,'PrimarySchool')" clearable maxlength="20" placeholder="请选择或准确输入就读初中">
                    <el-option v-for="item in jdxx" :key="item.BaseDataId" :value="item.DataName" />
                  </el-select>
                </td>
              </tr>
              <tr>
                <td class="center small rq" style="width:10%;">家长手机号码</td>
                <td class="center" colspan="19">
                  <el-input v-model="data.Mobile" class="red-inp" maxlength="11" v-int placeholder="报名时要用于接收手机验证码!"></el-input>
                </td>
              </tr>
              <tr>
                <td class="center bold" style="width:10%;">个人特长</td>
                <td class="center" style="width:16.25%;">等级</td>
                <td class="center" style="width:16.25%;">证书</td>
                <td class="center" colspan="22">表现说明</td>
              </tr>
              <tr>
                <td class="center" style="width:10%;height:34px;">
                  <el-input v-model="data.SpecialName1" maxlength="20" placeholder="请输入"></el-input>
                </td>
                <td class="center">
                  <el-input v-model="data.SpecialLv1" maxlength="10" placeholder="请输入"></el-input>
                </td>
                <td class="center">
                  <pic-upload2 v-if="!tbLoading" :data="{}" v-model="data.SpecialCertUrl1" />
                </td>
                <td class="center" colspan="22">
                  <el-input v-model="data.SpecialRemark1" maxlength="100" placeholder="请输入"></el-input>
                </td>
              </tr>
              <tr>
                <td class="center" style="width:10%;height:34px;">
                  <el-input v-model="data.SpecialName2" maxlength="20" placeholder="请输入"></el-input>
                </td>
                <td class="center">
                  <el-input v-model="data.SpecialLv2" maxlength="10" placeholder="请输入"></el-input>
                </td>
                <td class="center">
                  <pic-upload2 v-if="!tbLoading" :data="{}" v-model="data.SpecialCertUrl2" />
                </td>
                <td class="center" colspan="22">
                  <el-input v-model="data.SpecialRemark2" maxlength="100" placeholder="请输入"></el-input>
                </td>
              </tr>
              <tr>
                <td class="center bold" style="width:10%;">竞赛获奖</td>
                <td class="center">等级(区县以上)</td>
                <td class="center">证书</td>
                <td class="center" colspan="22">表现说明</td>
              </tr>
              <tr>
                <td class="center" style="width:10%;height:34px;">
                  <el-input v-model="data.AwardName1" maxlength="20" placeholder="请输入"></el-input>
                </td>
                <td class="center">
                  <el-input v-model="data.AwardLv1" maxlength="10" placeholder="请输入"></el-input>
                </td>
                <td class="center">
                  <pic-upload2 v-if="!tbLoading" :data="{}" v-model="data.AwardlCertUrl1" />
                </td>
                <td class="center" colspan="22">
                  <el-input v-model="data.AwardRemark1" maxlength="100" placeholder="请输入"></el-input>
                </td>
              </tr>
              <tr>
                <td class="center" style="width:10%;height:34px;">
                  <el-input v-model="data.AwardName2" maxlength="20" placeholder="请输入"></el-input>
                </td>
                <td class="center">
                  <el-input v-model="data.AwardLv2" maxlength="10" placeholder="请输入"></el-input>
                </td>
                <td class="center">
                  <pic-upload2 v-if="!tbLoading" :data="{}" v-model="data.AwardlCertUrl2" />
                </td>
                <td class="center" colspan="22">
                  <el-input v-model="data.AwardRemark2" maxlength="100" placeholder="请输入"></el-input>
                </td>
              </tr>
              <tr>
                <td class="center" rowspan="3" style="width:10%;">承诺：</td>
                <td class="center" colspan="24">我们郑重承诺，以上所填内容完全真实准确。<br/>否则，愿意承担取消遴选资格或录取资格的后果。</td>
              </tr>
              <tr>
                <td class="center">家长签名：</td>
                <td class="center bold" colspan="23">
                  <el-image v-if="data.ParentSignUrl" :src="'/api'+data.ParentSignUrl" fit="contain" :preview-src-list="['/api'+data.ParentSignUrl]" style="height: 80px;width: 160px;" />
                  <span v-else>(确认提交本信息表后，默认家长和考生签名完成!)</span>
                </td>
              </tr>
              <tr>
                <td class="center">学生签名：</td>
                <td class="center">
                  <el-image v-if="data.StudentSignUrl" :src="'/api'+data.StudentSignUrl" fit="contain" :preview-src-list="['/api'+data.StudentSignUrl]" style="height: 80px;width: 160px;" />
                </td>
                <td class="center" colspan="23" v-if="data.AddTime">{{toYMString(data.AddTime)}}</td>
                <td class="center" colspan="23" v-else>{{year}}年{{month}}月</td>
              </tr>
              <tr>
                <td class="bold" colspan="25">
                  <span class="red">特别提示：</span>
                  <span class="blue">1、本表打印完成后，须在“电子彩照”位置贴上近期一寸彩照，并完成签名!!</span>
                  <div class="blue" style="text-indent:5rem;">2、本表于参加遴选时交给现场老师。</div>
                </td>
              </tr>
            </table>
          </el-col>
        </el-row>
      </template>
      <template slot="footer">
        <span class="statusText" v-if="data.Junior6Id">状态：{{statusText}}</span>
        <el-button type="primary" @click="toSave">保 存</el-button>
        <el-button type="primary" @click="submit" v-if="data.Status==0||data.Status==2">提 交</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
const date = new Date();
const year = date.getFullYear();
const month = date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;

import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import picUpload from "../picUpload";
import picUpload2 from "../picUpload2";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    picUpload,
    picUpload2
  },
  data() {
    return {
      api: require("@/api/po/junior6").default,
      baseApi: require("@/api/po/basedata").default,
      data: {
        Junior6Id: 0,
        ParentId: 0,
        EnrollNo: "",
        FullName: "",
        Sex: null,
        IdCard: "",
        Domicile: "",
        BirthDate: "",
        PrimarySchool: "",
        SchoolDistrict: "",
        Mobile: "",
        //------------
        SpecialName1: "",
        SpecialLv1: "",
        SpecialCertUrl1: "",
        SpecialRemark1: "",
        SpecialName2: "",
        SpecialLv2: "",
        SpecialCertUrl2: "",
        SpecialRemark2: "",
        AwardName1: "",
        AwardLv1: "",
        AwardlCertUrl1: "",
        AwardRemark1: "",
        AwardName2: "",
        AwardLv2: "",
        AwardlCertUrl2: "",
        AwardRemark2: "",
        //------------
        PicUrl: "",
        ParentSignUrl: "",
        StudentSignUrl: "",
        Status: 0,
        AddTime: "",
      },
      tbLoading: true,
      setting: {
        EnableJunior6: true,
        SignStartDate: "",
        SignEndDate: "",
        PrintStartDate: "",
        PrintEndDate: "",
      },
      year,
      month,
      hjd: [],
      jdxx: [],
      xxssqx: [],
      isMB: this.$store.state.isMB,
      rules: {
        
      },
    };
  },
  computed: {
    statusText() {
      var result = "";
      switch (this.data.Status) {
        case 0:
          result = "待提交";
          break;
        case 1:
          result = "待审核";
          break;
        case 2:
          result = "审核未通过";
          break;
        case 3:
          result = "审核通过";
          break;
      }
      return result;
    }
  },
  methods: {
    onCreateOpened(data) {
      this.tbLoading = false;
      this.getBirth();
      this.getOption();
    },
    onEditOpened(data) {
      this.tbLoading = false;
      this.getOption();
    },
    getOption() {
      this.baseApi.list({ Status: 1 }).then(res => {
        if(res.Code==0) {
          this.hjd = res.Data.filter(x => x.ClassName == "户籍地");
          this.jdxx = res.Data.filter(x => x.ClassName == "就读小学");
          this.xxssqx = res.Data.filter(x => x.ClassName == "学校所属区县");
        } else this.$message.error(res.Msg);
      });
    },
    checkForm() {
      if(!this.data.FullName) {
        this.$message.error("请输入姓名");
        return false;
      }
      if(!this.data.Sex) {
        this.$message.error("请选择性别");
        return false;
      }
      if(!this.data.IdCard) {
        this.$message.error("请输入身份证号");
        return false;
      } else {
        let regex = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/;
        if(!regex.test(this.data.IdCard)) {
          this.$message.error("身份证格式不正确");
          return false;
        }
      }
      if(!this.data.Domicile) {
        this.$message.error("请输入户籍地");
        return false;
      }
      if(!this.data.BirthDate) {
        this.$message.error("请选择出生日期");
        return false;
      }
      if(!this.data.PrimarySchool) {
        this.$message.error("请输入就读小学");
        return false;
      }
      let regex2 = 11 && /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if(!regex2.test(this.data.Mobile)) {
        this.$message.error("请输入正确的家长手机号");
        return false;
      }
      if(!this.data.PicUrl) {
        this.$message.error("请上传照片");
        return false;
      }
      return true;
    },
    checkTJ() {
      var data = this.data;
      var self = this;
      var arr1 = ["SpecialName1","SpecialLv1","SpecialCertUrl1","SpecialRemark1"];
      var arr2 = ["SpecialName2","SpecialLv2","SpecialCertUrl2","SpecialRemark2"];
      var arr3 = ["AwardName1","AwardLv1","AwardlCertUrl1","AwardRemark1"];
      var arr4 = ["AwardName2","AwardLv2","AwardlCertUrl2","AwardRemark2"];
      if(!checkArr(arr1)) return false;
      if(!checkArr(arr2)) return false;
      if(!checkArr2(arr3)) return false;
      if(!checkArr2(arr4)) return false;
      return true;
      function checkArr(arr) {
        for (let i = 0; i < 4; i++) {
          if(data[arr[0]] && ( !data[arr[1]] || !data[arr[2]] || !data[arr[3]] )) {
            self.$message.error("个人特长信息不完整");
            return false;
          }
          if(data[arr[1]] && ( !data[arr[0]] || !data[arr[2]] || !data[arr[3]] )) {
            self.$message.error("个人特长信息不完整");
            return false;
          }
          if(data[arr[2]] && ( !data[arr[0]] || !data[arr[1]] || !data[arr[2]] )) {
            self.$message.error("个人特长信息不完整");
            return false;
          }
          if(data[arr[3]] && ( !data[arr[0]] || !data[arr[1]] || !data[arr[2]] )) {
            self.$message.error("个人特长信息不完整");
            return false;
          }
        }
        return true;
      }
      function checkArr2(arr) {
        for (let i = 0; i < 4; i++) {
          if(data[arr[0]] && ( !data[arr[1]] || !data[arr[2]] || !data[arr[3]] )) {
            self.$message.error("竞赛获奖信息不完整");
            return false;
          }
          if(data[arr[1]] && ( !data[arr[0]] || !data[arr[2]] || !data[arr[3]] )) {
            self.$message.error("竞赛获奖信息不完整");
            return false;
          }
          if(data[arr[2]] && ( !data[arr[0]] || !data[arr[1]] || !data[arr[2]] )) {
            self.$message.error("竞赛获奖信息不完整");
            return false;
          }
          if(data[arr[3]] && ( !data[arr[0]] || !data[arr[1]] || !data[arr[2]] )) {
            self.$message.error("竞赛获奖信息不完整");
            return false;
          }
        }
        return true;
      }
    },
    toSave() {
      if(!this.checkForm()) return false;
      if(!this.checkTJ()) return;
      this.loading(true);
      var sub = { ...this.data };
      delete sub.AddTime;
      this.api.save(sub).then(res => {
        this.loading(false);
        if(res.Code==0) {
          this.$message.success(res.Msg);
          this.close(true);
          this.$emit('close-saved');
        } else this.$message.error(res.Msg);
      })
    },
    submit() {
      if(!this.checkForm()) return false;
      if(!this.checkTJ()) return;
      this.loading(true);
      var sub = { ...this.data };
      delete sub.AddTime;
      this.api.submit(sub).then(res => {
        this.loading(false);
        if(res.Code==0) {
          this.$message.success(res.Msg);
          this.close(true);
          this.$emit('close-saved');
        } else this.$message.error(res.Msg);
      })
    },
    onBeforeSave() {
      return false;
    },
    getBirth(idCard=this.data.IdCard) {
      let regex = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/;
      if(!regex.test(idCard)) {
        this.$message.error("身份证格式不正确");
      }
      var birthday = "";  
      if(idCard != null && idCard != "") {  
          if(idCard.length == 15){  
              birthday = "19"+idCard.substr(6,6);  
          } else if(idCard.length == 18){  
              birthday = idCard.substr(6,8);  
          }
          birthday = birthday.replace(/(.{4})(.{2})/,"$1-$2-");  

          let genderCode; // 性别代码
          if (idCard.length == 18) { // 二代身份证号码长度为18位（第17位为性别代码）
              genderCode = idCard.charAt(16);
          } else if (idCard.length == 15) { // 一代身份证号码长度为15位（第15位为性别代码）
              genderCode = idCard.charAt(14);
          }
          if (genderCode && !isNaN(genderCode)) {
            // 两代身份证号码的性别代码都为男奇女偶
            if (parseInt(genderCode) % 2 == 0) {
              this.data.Sex = 2;
            } else this.data.Sex = 1;
          }
      }
      this.data.BirthDate = birthday||"";
    },
    toDateString(v) {
      if(!v) return "";
      var date = this.$commonJs.toDateString(v);
      var arr = date.split("/");
      return arr[0] + "年" + arr[1] + "月" + arr[2] + "日";
    },
    toYMString(v) {
      if(!v) return "";
      var date = this.$commonJs.toDateString(v);
      var arr = date.split("/");
      return arr[0] + "年" + arr[1] + "月";
    },
    selectInp(e,name) {
     let value = e.target.value;
      if(value) {
        this.data[name] = value
      }
    },
    onClosed() {
      this.tbLoading = true;
      this.hjd = [];
      this.jdxx = [];
      this.xxssqx = [];
    },
  }
};
</script>
<style lang="scss">
.report-table {
  border-spacing: 0;
  border-collapse: collapse;
  width: 100%;
  font-size: 16px;
  td {
    padding: 6px 8px;
  }
  .el-input,.el-select {
    width: 100%;
  }
  .center {
    text-align: center;
  }
  .right {
    text-align: right;
  }
  .red {
    color: #f11;
  }
  .blue {
    color: #11f;
  }
  .small {
    font-size: 14px;
  }
  .large {
    font-size: 18px;
  }
  .red-inp {
    .el-input__inner::placeholder {
      color: #f11;
    }
  }
}
.statusText {
  color:#F11;
  float:left;
  font-weight: bold;
  line-height: 34px;
  margin-left: 8px;
  font-size: 16px;
}
.rq:before {content: '* ';color: red;}
</style>